module.exports = __webpack_public_path__ + "static/media/download-clauses.6d32f0ed.svg";